export const EA_TRAVEL_RATES_LOGIN_DETAILS = 'eaTravelRates/loginDetails/';
export const COLLECT_LOGIN_DETAILS = EA_TRAVEL_RATES_LOGIN_DETAILS + 'collectLoginDetails/';
export const LOGIN_SUCCESS = EA_TRAVEL_RATES_LOGIN_DETAILS + 'loginSuccess/';
export const LOGIN_FAILURE = EA_TRAVEL_RATES_LOGIN_DETAILS + 'loginFailure/';
export const API_PENDING_LOGIN = EA_TRAVEL_RATES_LOGIN_DETAILS + 'apiPendingLogin/';
export const API_SUCCESS_LOGIN = EA_TRAVEL_RATES_LOGIN_DETAILS + 'apiSuccessLogin/';
export const API_FAILURE_LOGIN = EA_TRAVEL_RATES_LOGIN_DETAILS + 'apiFailureLogin/';

export const COLLECT_AUTH_LOGIN_DETAILS = EA_TRAVEL_RATES_LOGIN_DETAILS + 'collectAuthLoginDetails/';
export const AUTH_LOGIN_SUCCESS = EA_TRAVEL_RATES_LOGIN_DETAILS + 'authLoginSuccess/';
export const AUTH_LOGIN_FAILURE = EA_TRAVEL_RATES_LOGIN_DETAILS + 'authLoginFailure/';
export const API_PENDING_AUTH_LOGIN = EA_TRAVEL_RATES_LOGIN_DETAILS + 'apiPendingAuthLogin/';
export const API_SUCCESS_AUTH_LOGIN = EA_TRAVEL_RATES_LOGIN_DETAILS + 'apiSuccessAuthLogin/';
export const API_FAILURE_AUTH_LOGIN = EA_TRAVEL_RATES_LOGIN_DETAILS + 'apiFailureAuthLogin/';

export const VERIFY_DETAILS = EA_TRAVEL_RATES_LOGIN_DETAILS + 'verifyDetails/';
export const VERIFY_SUCCESS = EA_TRAVEL_RATES_LOGIN_DETAILS + 'verifySuccess/';
export const VERIFY_FAILURE = EA_TRAVEL_RATES_LOGIN_DETAILS + 'verifyFailure/';
export const API_INITIAL_VERIFY = EA_TRAVEL_RATES_LOGIN_DETAILS + 'apiInitialVerify/';
export const API_PENDING_VERIFY = EA_TRAVEL_RATES_LOGIN_DETAILS + 'apiPendingVerify/';
export const API_SUCCESS_VERIFY = EA_TRAVEL_RATES_LOGIN_DETAILS + 'apiSuccessVerify/';
export const API_FAILURE_VERIFY = EA_TRAVEL_RATES_LOGIN_DETAILS + 'apiFailureVerify/';

export const collectLoginDetails = () => ({
    type: COLLECT_LOGIN_DETAILS,
});

export const loginSuccess = (data) => ({
    type: LOGIN_SUCCESS,
    data,
});

export const loginFailure = (error) => ({
    type: LOGIN_FAILURE,
    error,
});

export const apiPendingLogin = () => ({
    type: API_PENDING_LOGIN,
});

export const apiSuccessLogin = () => ({
    type: API_SUCCESS_LOGIN,
});

export const apiFailureLogin = () => ({
    type: API_FAILURE_LOGIN,
});

export const apiTransitionLogin = {
    pending: apiPendingLogin,
    success: apiSuccessLogin,
    failure: apiFailureLogin,
};

export const collectAuthLoginDetails = () => ({
    type: COLLECT_AUTH_LOGIN_DETAILS,
});

export const authLoginSuccess = (data) => ({
    type: AUTH_LOGIN_SUCCESS,
    data,
});

export const authLoginFailure = (error) => ({
    type: AUTH_LOGIN_FAILURE,
    error,
});

export const apiPendingAuthLogin = () => ({
    type: API_PENDING_AUTH_LOGIN,
});

export const apiSuccessAuthLogin = () => ({
    type: API_SUCCESS_AUTH_LOGIN,
});

export const apiFailureAuthLogin = () => ({
    type: API_FAILURE_AUTH_LOGIN,
});

export const apiTransitionAuthLogin = {
    pending: apiPendingAuthLogin,
    success: apiSuccessAuthLogin,
    failure: apiFailureAuthLogin,
};

export const verifyDetails = () => ({
    type: VERIFY_DETAILS,
});

export const verifySuccess = (data) => ({
    type: VERIFY_SUCCESS,
    data,
});

export const verifyFailure = (error) => ({
    type: VERIFY_FAILURE,
    error,
});

export const apiInitialVerify = () => ({
    type: API_INITIAL_VERIFY,
});

export const apiPendingVerify = () => ({
    type: API_PENDING_VERIFY,
});

export const apiSuccessVerify = () => ({
    type: API_SUCCESS_VERIFY,
});

export const apiFailureVerify = () => ({
    type: API_FAILURE_VERIFY,
});

export const apiTransitionVerify = {
    initial: apiInitialVerify,
    pending: apiPendingVerify,
    success: apiSuccessVerify,
    failure: apiFailureVerify,
};

export const EA_TRAVEL_RATES_AUTH_FORM = 'eaTravelRates/authForm/';
export const EA_TRAVEL_RATES_AUTH_FORM_SET_VALUE = EA_TRAVEL_RATES_AUTH_FORM + 'setValue';
export const EA_TRAVEL_RATES_AUTH_FORM_SET_VALID = EA_TRAVEL_RATES_AUTH_FORM + 'setValid';

export const EMAIL_SET_VALUE = EA_TRAVEL_RATES_AUTH_FORM_SET_VALUE + 'email';
export const EMAIL_SET_VALID = EA_TRAVEL_RATES_AUTH_FORM_SET_VALID + 'email';

export const OTP_SET_VALUE = EA_TRAVEL_RATES_AUTH_FORM_SET_VALUE + 'otp';
export const OTP_SET_VALID = EA_TRAVEL_RATES_AUTH_FORM_SET_VALID + 'otp';

export const SHOW_OTP_SCREEN_VALUE = EA_TRAVEL_RATES_AUTH_FORM_SET_VALUE + 'showOtpScreen';
export const SHOW_OTP_SCREEN_VALID = EA_TRAVEL_RATES_AUTH_FORM_SET_VALUE + 'showOtpScreen';

export const REINITIALIZE = EA_TRAVEL_RATES_AUTH_FORM + '/state/reinitialize';

export const setEmailValue = (value) => ({
    type: EMAIL_SET_VALUE,
    value,
});
export const setEmailValid = (error) => ({
    type: EMAIL_SET_VALID,
    error,
});

export const setOtpValue = (value) => ({
    type: OTP_SET_VALUE,
    value,
});
export const setOtpValid = (error) => ({
    type: OTP_SET_VALID,
    error,
});

export const setShowOtpScreenValue = (value) => ({
    type: SHOW_OTP_SCREEN_VALUE,
    value,
});
export const setShowOtpScreenValid = (error) => ({
    type: SHOW_OTP_SCREEN_VALID,
    error,
});

export const initializeAuthForm = () => ({
    type: REINITIALIZE,
});
